import React from 'react';
import SkeletonBlock from '../ui/SkeletonBlock';

const compactTileShell =
  'flex h-full min-h-[72px] flex-col justify-between rounded-xl border border-primary-500/10 bg-white p-2.5 shadow-card sm:p-3';

/** Matches StatTile compact — label, icon, value, subtext. */
export function StatTileCompactSkeleton() {
  return (
    <div className={compactTileShell}>
      <div className="mb-1 flex items-start justify-between">
        <SkeletonBlock className="h-2.5 w-16" />
        <SkeletonBlock className="h-5 w-5 rounded-md" />
      </div>
      <div>
        <SkeletonBlock className="mb-1 h-6 w-[2.75rem] rounded sm:h-7 sm:w-14" />
        <SkeletonBlock className="h-2.5 w-24" />
      </div>
    </div>
  );
}

/** Region tile — top region value + runner subtext line. */
export function RegionTileSkeleton() {
  return (
    <div className={compactTileShell}>
      <div className="mb-1.5 flex items-start justify-between">
        <SkeletonBlock className="h-3 w-16" />
        <SkeletonBlock className="h-6 w-6 rounded-lg" />
      </div>
      <div>
        <SkeletonBlock className="mb-1 h-7 w-10" />
        <SkeletonBlock className="h-3 w-full max-w-[140px]" />
      </div>
    </div>
  );
}

/** Four-tile grid matching ProspectMetricTiles layout. */
export function ProspectMetricTilesSkeleton() {
  return (
    <div
      className="mb-3 grid grid-cols-2 gap-3 lg:grid-cols-4"
      aria-hidden
    >
      <StatTileCompactSkeleton />
      <StatTileCompactSkeleton />
      <RegionTileSkeleton />
      <StatTileCompactSkeleton />
    </div>
  );
}

/** Investor dashboard MetricCell value/subtext placeholder. */
export function MetricCellValueSkeleton({ className = '' }: { className?: string }) {
  return (
    <div className={`mt-2 space-y-1.5 ${className}`} aria-hidden>
      <SkeletonBlock className="h-6 w-20" />
      <SkeletonBlock className="h-3 w-24" />
    </div>
  );
}
